import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { StoreContext } from "shared/context/store-context";

import ItemHeader from "layouts/ItemHeader";

const TransferInfo = ({ transfer, onClose }) => {
  const { t } = useTranslation();
  const { schoolOptions } = useContext(StoreContext);

  const schoolLabel = schoolOptions.find((option) => option.value === transfer.school.toString())?.label || "";
  let leftTitle = schoolLabel;
  if (leftTitle.toLowerCase().includes("freebird")) {
    leftTitle = t("transferInfo.freebirdFlightTransfer");
  }

  return (
    <React.Fragment>
      {transfer && (
        <ItemHeader onClose={onClose}>
          <h4 style={{ margin: "0px" }}>{leftTitle}</h4>

          <span>
            <strong>{t("transferInfo.routeTypeLabel")}</strong>{" "}
            {transfer.type.toString() === "100"
              ? t("transferReport.transferTypePickup")
              : t("transferReport.transferTypeDropoff")}
          </span>

          <span>
            <strong>{t("transferInfo.dateLabel")}</strong> {transfer.transferdate}
          </span>

          <span>
            <strong>{t("transferInfo.flightLabel")}</strong> {transfer.name}
          </span>

          <span>
            <strong>
              {transfer.type.toString() === "100"
                ? t("transferInfo.preDepartureArrivalLabel")
                : t("transferInfo.postArrivalArrivalLabel")}{" "}
            </strong>{" "}
            {transfer.transfertime.split(" ")[4].substring(0, 5)}
          </span>
        </ItemHeader>
      )}
    </React.Fragment>
  );
};

export default TransferInfo;
